<template>
  <div class="portlet_wrapper">
    <div class="switch_label">
      <div v-for="trade_event_name in trade_events_name" :key="trade_event_name"
        @click="tap_trade_events_label(trade_event_name)"
        :class="{ active: active_trade_event_name == trade_event_name }">{{ trade_event_name }}</div>
    </div>
    <select v-model="active_trade_event_name" @change="tap_trade_events_label(active_trade_event_name)">
      <option v-for="trade_event_name in trade_events_name" :key="trade_event_name">{{ trade_event_name }}</option>
    </select>

    <div class="cnt_block">
      <div class="info">
        <div>
          <div class="small_title">兌換期間</div>
          <div class="date">{{ cur_trade_event.trade_start_date }}~{{ cur_trade_event.trade_end_date }}</div>
        </div>

        <div>
          <div class="small_title count">可使用點數總計</div>
          <div class="button">{{ allEventSquadTotalGetter }}點</div>
        </div>
      </div>

      <hr />

      <div class="item">
        <div class="small_title">活動商品</div>
        <div class="table_holder">
          <table>
            <thead>
              <tr>
                <th>品名</th>
                <th>兌換點數</th>
                <th>備註</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tr in eventCanTradeListGetter">
                <td>{{ tr.item_name }}</td>
                <td>{{ tr.item_cost }}</td>
                <td>{{ tr.item_note }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <div class="small_title">參與項目</div>

        <template v-if="cur_trade_event.multiple_enable">
          <div class="small_label">
            <div v-for="squad_name in squads" :key="squad_name" @click="tap_squad_label(squad_name)"
              :class="{ active: active_squad == squad_name }">{{ squad_name }}</div>
          </div>
          <select v-model="active_squad" @change="tap_squad_label(active_squad)">
            <option v-for="squad_name in squads" :key="squad_name">{{ squad_name }}</option>
          </select>
        </template>

        <div class="table_holder">
          <table>
            <thead>
              <tr>
                <th>日期</th>
                <th>時間</th>
                <th>說明</th>
                <th>獲得點數</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tr in curStudentPointList.squad_point_list || []">
                <td v-if="tr.event_start_date == tr.event_end_date">{{ tr.event_start_date }}</td>
                <td v-else>{{ tr.event_start_date }}~{{ tr.event_end_date }}</td>
                <td v-if="tr.event_end_time != NULL">{{ tr.event_start_time }}~{{ tr.event_end_time }}</td>
                <td v-else>{{ tr.event_start_time }}</td>
                <td>{{ tr.description }}</td>
                <td>{{ tr.amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="total_available_points">
          可使用點數總計：<span>{{ curStudentPointList.squad_total || 0 }}</span>點
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'RedeemableList',
  components: {
  },
  props: {
    currentStudent: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      active_trade_event_name: '-',
      trade_events_name: [],
      active_squad: '-',
      squads: [],
      cur_trade_event: {},
      curStudentPointList: {},
    }
  },
  computed: {
    ...mapGetters('pages/point', [
      'tradeEventsGetter',
      'eventCanTradeListGetter',
      'allEventSquadTotalGetter',
      'studentPointListGetter',
    ]),
  },
  watch: {
    tradeEventsGetter(value) {
      this.trade_events_name = [...value].map(trade_event => trade_event.event_name);
      this.active_trade_event_name = this.trade_events_name[0];
      this.trade_events = [...value];
      this.cur_trade_event = this.trade_events[0] || {};
      this.update_view_trade_event();
    },
    currentStudent() {
      this.update_view_trade_event();
    },
    studentPointListGetter() {
      this.update_view_squad();
    }
  },
  created() {
    this.togglePageLoader(true);
    this.getTradeEvent().then(() => this.togglePageLoader(false))
      .catch(() => this.togglePageLoader(false));
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/point', [
      'getTradeEvent',
      'getEventCanTradeList',
      'getStudentPointListByEvent',
    ]),

    tap_trade_events_label(trade_event_name) {
      this.active_trade_event_name = trade_event_name;
      let index = this.trade_events_name.indexOf(trade_event_name);
      this.cur_trade_event = this.trade_events[index] || {};
      this.togglePageLoader(true);
      this.update_view_trade_event().then(() => this.togglePageLoader(false))
        .catch(() => this.togglePageLoader(false));
    },
    async update_view_trade_event() {
      if (!Object.keys(this.cur_trade_event).length) return;
      this.squads = [...this.cur_trade_event.event_squad];
      this.active_squad = this.squads[0];
      await this.getEventCanTradeList({
        'event-id': this.cur_trade_event.event_id,
      });

      if(this.currentStudent){
        await this.getStudentPointListByEvent({
        'trade_event_id': this.cur_trade_event.event_id,
        'student_id': this.currentStudent.student_pk_id,
        'find_trade_record': 'Y'
      });
      }

    },

    tap_squad_label(squad) {
      this.active_squad = squad;
      this.update_view_squad();
    },
    update_view_squad() {
      let index = this.squads.indexOf(this.active_squad);
      this.curStudentPointList = this.studentPointListGetter[index] || {};
    },
  }
}
</script>